import React from 'react'
import Select from '@peracto/peracto-editor-ui/dist/Select'
import Checkbox from '@peracto/peracto-editor-ui/dist/Checkbox'
import {
    SIDE_BY_SIDE_FROM,
    SIDE_BY_SIDE_FROM_OPTIONS,
    resolveSideBySideFrom,
} from '../sideBySideFrom'

const ContainerForm = ({
    onChange,
    state: {
        containerSize = 'full',
        containerType = 'fluid',
        aspectRatio = '',
        alignContent = 'center',
        justifyContent = 'flex-start',
        matchContentHeight,
        sideBySideFrom,
        mobileTwoColumnLayout,
    },
}) => {
    const resolvedSideBySideFrom = resolveSideBySideFrom({
        sideBySideFrom,
        mobileTwoColumnLayout,
    })

    return (
        <>
            <Select
                label="Container Size"
                value={containerSize}
                onChange={(e) => onChange({ containerSize: e.value })}
                options={[
                    { label: 'Full Width', value: 'full' },
                    { label: 'Wide', value: 'wide' },
                    { label: 'Standard', value: 'standard' },
                    { label: 'Narrow', value: 'narrow' },
                    { label: 'Menu Container', value: 'container' },
                ]}
            />

            <Select
                label="Container Type"
                value={containerType}
                onChange={(e) => onChange({ containerType: e.value })}
                options={[
                    { label: 'Fluid', value: 'fluid' },
                    { label: 'Fixed', value: 'fixed' },
                ]}
            />

            <Select
                label="Container Aspect Ratio"
                value={aspectRatio}
                onChange={(e) => onChange({ aspectRatio: e.value })}
                options={[
                    { label: 'Dynamic', value: '' },
                    { label: '1:1', value: '1:1' },
                    { label: '16:9', value: '16:9' },
                    { label: '4:3', value: '4:3' },
                    { label: '2:1', value: '2:1' },
                ]}
            />

            <Select
                label="Vertically Align Content"
                value={alignContent}
                onChange={(e) => onChange({ alignContent: e.value })}
                options={[
                    { label: 'Top', value: 'flex-start' },
                    { label: 'Centre', value: 'center' },
                    { label: 'Bottom', value: 'flex-end' },
                ]}
            />

            <Select
                label="Horizontally Align Content"
                value={justifyContent}
                onChange={(e) => onChange({ justifyContent: e.value })}
                options={[
                    { label: 'Left', value: 'flex-start' },
                    { label: 'Centre', value: 'center' },
                    { label: 'Right', value: 'flex-end' },
                ]}
            />

            <Checkbox
                label="Match Content Height"
                checked={matchContentHeight}
                onChange={(e) => onChange({ matchContentHeight: e.target.checked })}
            />

            <Select
                label="Stack in Column"
                value={resolvedSideBySideFrom}
                onChange={(e) =>
                    onChange({
                        sideBySideFrom: e.value,
                        // Keep legacy flag in sync for older consumers / storefront CSS
                        mobileTwoColumnLayout: e.value === SIDE_BY_SIDE_FROM.ALWAYS,
                    })
                }
                options={SIDE_BY_SIDE_FROM_OPTIONS}
            />
            <p style={{ marginTop: '-0.5rem', marginBottom: '1rem', fontSize: '0.75rem', color: '#666' }}>
                If this container has multiple elements, they form a column below the
                selected breakpoint and appear side by side in a row above it.
            </p>
        </>
    )
}

export default ContainerForm
